import {getCurrentCompany, getStoredCompanyList} from './company'

export const SUBSCRIPTION_ACCESS_ALLOWED = 'allowed';
export const SUBSCRIPTION_ACCESS_PRO_REQUIRED = 'proRequired';
export const SUBSCRIPTION_ACCESS_PREMIUM_REQUIRED = 'premiumRequired';

function requireLoginInformation() {
    const stored = localStorage.getItem('loginInformation');
    if (stored == null || stored === '') {
        throw new Error('loginInformation is required');
    }
    const loginInformation = JSON.parse(stored).objectData;
    if (loginInformation == null || loginInformation.id == null) {
        throw new Error('loginInformation.objectData.id is required');
    }
    return loginInformation;
}

function currentTimestampSeconds() {
    return Math.floor(Date.now() / 1000);
}

export function hasSubscriptionAccess(loginInformation) {
    if (loginInformation == null || loginInformation.expiresTime == null) {
        throw new Error('expiresTime is required');
    }
    return Number(loginInformation.expiresTime) > currentTimestampSeconds();
}

export function getCurrentPlanName(loginInformation) {
    if (!hasSubscriptionAccess(loginInformation)) {
        return 'Free';
    }
    const planType = String(loginInformation.planType).toLowerCase();
    if (planType === 'pro') {
        return 'Pro';
    }
    if (planType === 'premium') {
        return 'Premium';
    }
    return 'Free';
}

export function isSubscriptionExpired(loginInformation) {
    if (loginInformation == null || loginInformation.iapStatus == null) {
        throw new Error('iapStatus is required');
    }
    const subscribedBefore = loginInformation.iapStatus === 3
        || loginInformation.iapStatus === 4
        || loginInformation.iapStatus === 5;
    return subscribedBefore && !hasSubscriptionAccess(loginInformation);
}

export function getActiveCompanyList(companyList) {
    if (!Array.isArray(companyList)) {
        throw new Error('companyList is required');
    }
    return companyList.filter(company => company.syncStatus === 0 || company.syncStatus === 2);
}

export function getPrimaryCompany(companyList) {
    const activeCompanies = getActiveCompanyList(companyList).slice();
    if (activeCompanies.length === 0) {
        throw new Error('An active company is required');
    }
    activeCompanies.forEach(company => {
        if (!Number.isFinite(Number(company.createDate))) {
            throw new Error('Company createDate is required');
        }
        if (company.id == null) {
            throw new Error('Company id is required');
        }
    });
    activeCompanies.sort((left, right) => {
        const createDateDifference = Number(left.createDate) - Number(right.createDate);
        if (createDateDifference !== 0) {
            return createDateDifference;
        }
        return Number(left.id) - Number(right.id);
    });
    return activeCompanies[0];
}

export function getDocumentCreationAccess(loginInformation, companyList, currentCompany) {
    if (!hasSubscriptionAccess(loginInformation)) {
        return SUBSCRIPTION_ACCESS_PRO_REQUIRED;
    }
    if (String(loginInformation.planType).toLowerCase() === 'premium') {
        return SUBSCRIPTION_ACCESS_ALLOWED;
    }
    if (currentCompany == null || currentCompany.innerUUID == null) {
        throw new Error('Current company is required');
    }
    return getPrimaryCompany(companyList).innerUUID === currentCompany.innerUUID
        ? SUBSCRIPTION_ACCESS_ALLOWED
        : SUBSCRIPTION_ACCESS_PREMIUM_REQUIRED;
}

export function getStoredDocumentCreationAccess() {
    return getDocumentCreationAccess(
        requireLoginInformation(),
        getStoredCompanyList(),
        getCurrentCompany()
    );
}

export function canCreateNewCompany(loginInformation) {
    return hasSubscriptionAccess(loginInformation)
        && String(loginInformation.planType).toLowerCase() === 'premium';
}

export function getStoredCurrentPlanName() {
    return getCurrentPlanName(requireLoginInformation());
}

export function getFastSpringPageUrl(currentPlan, selectedPlan) {
    const loginInformation = requireLoginInformation();
    if (['Free', 'Pro', 'Premium'].indexOf(currentPlan) === -1) {
        throw new Error('currentPlan must be Free, Pro or Premium');
    }
    if (['Pro', 'Premium'].indexOf(selectedPlan) === -1) {
        throw new Error('selectedPlan must be Pro or Premium');
    }
    return window.location.origin + '/FastSpringPage.html?grqerewrfa=' + encodeURIComponent(loginInformation.id)
        + '&currentPlan=' + encodeURIComponent(currentPlan)
        + '&selectedPlan=' + encodeURIComponent(selectedPlan);
}

export function openFastSpringPage(currentPlan, selectedPlan) {
    window.location.href = getFastSpringPageUrl(currentPlan, selectedPlan);
}
